import { createSelector } from '@reduxjs/toolkit';
import type { EmployeeViewModelWithName } from '../../types';
import { getOrganization } from '../organization/getOrganization';
import { _sortByFirstAndLastName } from '../utilities/_sortByFirstAndLastName';
import { toList } from '../toList';

export const employeesNotDeleted = createSelector(getOrganization, (organization): EmployeeViewModelWithName[] => {
  if (organization === undefined) {
    return [];
  }
  return toList(organization.employeesById)
    .filter(function (e) {
      return !e.deleted;
    })
    .sort(_sortByFirstAndLastName);
});
